export default (tooglerSelector, targerSelector, className) => {
  const toggler = $(tooglerSelector)
  const target = $(targerSelector)
  toggler.click(function(e) {
    e.preventDefault()
    target.toggleClass(className)
  })
}
